// extracted by mini-css-extract-plugin
export default {"loaderContainer":"LoaderBlock_loaderContainer__gatE4"};